import React from 'react'
import { Outlet } from 'react-router-dom'
import './AuthLayout.css'

function AuthLayout() {
  return (
    <div className="auth-layout">
      <div className="auth-background">
        <div className="auth-gradient"></div>
        <div className="auth-pattern"></div>
      </div>

      <div className="auth-container">
        <div className="auth-brand">
          <a href="https://neighbortopia.app" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="auth-logo">
              <img src="/logo.jpeg" alt="NeighborTopia" style={{ width: 48, height: 48, borderRadius: 12 }} />
            </div>
            <h1 className="auth-title">NeighborTopia</h1>
          </a>
          <p className="auth-tagline">Connect with your neighborhood community</p>
        </div>

        <div className="auth-card">
          <Outlet />
        </div>

        <footer className="auth-footer">
          <p>&copy; {new Date().getFullYear()} NeighborTopia. All rights reserved.</p>
        </footer>
      </div>
    </div>
  )
}

export default AuthLayout
